import PropTypes from 'prop-types';
// material-ui
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

// project import
import NavItem from './NavItem';
import { useGetMenuMaster } from 'api/menu';
import { useAuth } from 'contexts/AuthContext';

// ==============================|| NAVIGATION - LIST GROUP ||============================== //

export default function NavGroup({ item }) {
  const { menuMaster } = useGetMenuMaster();
  const drawerOpen = menuMaster.isDashboardDrawerOpened;
  const { role } = useAuth();
  const userRole = String(role || '').trim().toLowerCase();

  if (Array.isArray(item.roles) && item.roles.length > 0) {
    const allowedGroups = item.roles.map((r) => String(r).trim().toLowerCase());
    if (!allowedGroups.includes(userRole)) {
      return null;
    }
  }

  const visibleChildren = item.children?.filter((menuItem) => {
    if (!menuItem.roles?.length) {
      return true;
    }
    const allowed = menuItem.roles.map((r) => String(r).trim().toLowerCase());
    return allowed.includes(userRole);
  });

  if (!visibleChildren?.length) {
    return null;
  }

  const navCollapse = visibleChildren.map((menuItem) => {
    switch (menuItem.type) {
      case 'collapse':
        return (
          <Typography key={menuItem.id} variant="caption" color="error" sx={{ p: 2.5 }}>
            collapse - only available in paid version
          </Typography>
        );
      case 'item':
        return <NavItem key={menuItem.id} item={menuItem} level={1} />;
      default:
        return (
          <Typography key={menuItem.id} variant="h6" color="error" align="center">
            Fix - Group Collapse or Items
          </Typography>
        );
    }
  });

  return (
    <List
      subheader={
        item.title &&
        drawerOpen && (
          <Box sx={{ pl: 3, mb: 1.5 }}>
            <Typography variant="subtitle2" color="textSecondary">
              {item.title}
            </Typography>
            {/* only available in paid version */}
          </Box>
        )
      }
      sx={{ mb: drawerOpen ? 1.5 : 0, py: 0, zIndex: 0 }}
    >
      {navCollapse}
    </List>
  );
}

NavGroup.propTypes = { item: PropTypes.object };
